var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailboxD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M381.028 24.16H130.971C58.755 24.16 0 82.912 0 155.129v201.2a16 16 0 0 0 16 16h213.94v99.511a16 16 0 0 0 16 16h78.46a16 16 0 0 0 16-16v-99.515H496a16 16 0 0 0 16-16v-201.2C512 82.912 453.245 24.16 381.028 24.16zM32 340.325v-185.2a98.969 98.969 0 0 1 197.938 0v185.2zM308.4 455.84h-46.46v-83.515h46.46zM480 340.325H261.94v-185.2a130.712 130.712 0 0 0-45.279-98.965h164.368A99.081 99.081 0 0 1 480 155.129zM189.8 170.042a16 16 0 0 1-16 16H85a16 16 0 1 1 0-32h88.8a16 16 0 0 1 16 16z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailboxD);
export default __webpack_public_path__ + "static/media/mailbox-D.a89caa9fa5447c309eef225461abe485.svg";
export { ForwardRef as ReactComponent };